const Route = (route) => {
    window.location = route
}

export default Route